import React from "react";
import { Button } from "@material-ui/core";
import { get, isEmpty } from "lodash";
import Link from "./../components/Link";

export default function renderButtons(buttons) {
  return buttons.map((button, i) => {
    const buttonVariant = (button.button_variant || "").toLowerCase();
    const squiggleClassName = buttonVariant.includes("squiggle");
    const buttonClassName = squiggleClassName
      ? "cms-button cms-button-squiggle squiggle-variant"
      : "cms-button cms-button-contained";
    const linkClassName = buttonVariant.includes("squiggle")
      ? "cms-button-link-squiggle"
      : "cms-button-link-contained";

    if (button.onclick) {
      return (
        <Link url="#" className={linkClassName}>
          <Button
            variant={button.button_variant}
            color={button.button_color}
            className={buttonClassName}
            disableElevation
            onClick={button.onclick ? button.onclick : null}
          >
            {button.cta_text[0].text || button.cta_text}
          </Button>
        </Link>
      );
    } else if (
      !isEmpty(button.cta_text) &&
      (get(button, "cta_text[0].text") || button.cta_text) &&
      (button.cta_link.url || button.cta_link.uid)
    ) {
      return (
        <Link
          key={i}
          to={"/" + get(button, "cta_link.uid")}
          url={get(button, "cta_link.url")}
          target={get(button, "cta_link.target")}
          className={linkClassName}
        >
          <Button
            variant={button.button_variant}
            color={button.button_color}
            className={buttonClassName}
            disableElevation
          >
            {button.cta_text[0].text || button.cta_text}
          </Button>
        </Link>
      );
    }
  });
}
